import { TCustomNextPage } from '@/types'
import { SEO } from '@molecules/index'
import { PasswordRecoverySection } from '@organisms/index'
import DefaultLayout from '@templates/default-layout'

const PasswordRecoveryPage: TCustomNextPage = () => {
  return (
    <>
      <SEO title="Recuperar Contraseña" />
      <DefaultLayout displayFloatingButton={false}>
        <PasswordRecoverySection />
      </DefaultLayout>
    </>
  )
}

PasswordRecoveryPage.gCaptcha = true

export default PasswordRecoveryPage
